import { createQueryKeys } from "@lukemorales/query-key-factory";
import { IdentityProvidersApi } from "mws-ts-v2-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getIdentityProvidersApi = () => {
  return new IdentityProvidersApi(
    undefined,
    useRuntimeConfig().public.identityServiceUrl,
    getUniversalAxios(),
  );
};

export const identityProvidersQueryKeys = createQueryKeys("identityProviders", {
  providers: () => {
    return {
      queryKey: ["identityProviders"],
      queryFn: async () => {
        const response = await getIdentityProvidersApi().v2ProvidersGet();

        return response.data;
      },
    };
  },
});
